import React from 'react';

import { Layout } from '../components/common';
import { MetaData } from '../components/common/meta';
import { FinancialToolsOfferWall } from '../components/FinancialToolsOfferWall/FinancialToolsOfferWall';
import { Hero } from '../components/InnerPages/Hero';
import WillIcon from '../images/Will';

import style from '../styles/pages/extra-money.scss';

import { Helmet } from 'react-helmet';

interface IWillProps {
  location: any;
}

const Will = ({ location }: IWillProps) => {
  return (
    <>
      <Helmet>
        <script type="text/javascript">{`
       var _clcktt = _clcktt || {};
        _clcktt['cIdDesktop'] = "104837";
        _clcktt['cIdMobile'] = "200810";
        (function() {
            var ca = document.createElement('script'); ca.type = 'text/javascript';
            ca.async = true;
            ca.src = '//revpie.com/api/js/extractor.js';
            var sc = document.getElementsByTagName('script')[0]; sc.parentNode.insertBefore(ca, sc);
        })();
      `}</script>
        <style>{`
        .container {
          background-color: initial !important;
        }

        main > div {
          background-color: #fff;
        }
      `}</style>
      </Helmet>
      <MetaData data={{}} location={location} title="Create Your Will in Minutes " />
      <Layout headerClassName={style.header} mainClass={style.main}>
        <Hero
          className={style.hero}
          icon={<WillIcon />}
          title="Create Your Will in Minutes "
          description="Ensure your loved ones are cared for with a legally valid will. We guide you through the process step by step—fast, secure, and hassle-free. Start now!"
        />
        <div className={style.content}>
          <div className="container">
            <div id="clcktt"></div>
            <FinancialToolsOfferWall
              items={[
                {
                  title: 'What is a Will',
                  link: '/what-is-a-will/',
                },
                {
                  title: 'Future Planning',
                  link: '/tag/future-planning/',
                },
                {
                  title: 'How to write a will',
                  link: '/how-to-write-a-will/',
                },
              ]}
            />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Will;
